// Types
import type { TAuthStore } from '~/modules/auth/store/types';
import type { TUser } from '~/misc/auth/types';

// Store
import { useAuthStore } from '~/modules/auth/store';

// Services
import { AuthAccess } from '~/misc/auth/services/access';

// Composables
import { useIsAdminPath } from '~/composables/use-is-admin-path';

export default defineNuxtRouteMiddleware((_to, _from) => {
  const store: TAuthStore = useAuthStore();
  const { isAdminPath } = useIsAdminPath();

  watch(
    () => store.user,
    (user: TUser | null) => {
      if (!user) return;

      if (!isAdminPath(_to.path)) return;

      if (!!store.user && AuthAccess.canAdministrate(store.user)) return;

      return abortNavigation({ statusCode: 403 });
    }
  );
});
